import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { DEMO_MODE } from '@demo/config';

// The public demo build never authenticates anybody: src/firebase/auth.js
// answers from a fixture instead of the SDK. It is still initialised (the SDK
// makes no network call until an auth operation runs) but with a placeholder
// project, so the real project's identifiers are not published inside a
// marketing page.
const demoConfig = {
  apiKey: 'demo-not-a-key',
  authDomain: 'demo.invalid',
  projectId: 'retroact-demo',
  storageBucket: 'demo.invalid',
  messagingSenderId: '0',
  appId: '1:0:web:demo'
};

// The clinical app's real project.
const realConfig = {
  apiKey: "AIzaSyD85SpficYQHZ38cNym0lpCFv2UrUj9dl8",
  authDomain: "retroact-fb.firebaseapp.com",
  projectId: "retroact-fb",
  storageBucket: "retroact-fb.firebasestorage.app",
  messagingSenderId: "3766473485",
  appId: "1:3766473485:web:f47ca5c85a89f226781644"
};

const firebaseConfig = DEMO_MODE ? demoConfig : realConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set persistence to LOCAL to help with cross-origin navigation. Skipped in the
// demo build: there is no session to persist, and the call would fail against
// the placeholder project.
if (!DEMO_MODE) {
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error('Failed to set auth persistence:', error);
  });
}

export default app;
